import { render, staticRenderFns } from "./shippingCost.vue?vue&type=template&id=31b322cb"
import script from "./shippingCost.vue?vue&type=script&lang=js"
export * from "./shippingCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports